// Progressive-enhancement bridge for the Capacitor native shell.
// On web this is inert (isNative=false) so existing browser behavior is UNCHANGED.
// On native (iOS/Android) it exposes the device camera + secure storage, reusing the
// SAME upload APIs — no duplicate business logic. Nothing here is imported by the web
// build yet; wiring into DuruScan is an explicit, reviewable follow-up step.
import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'web' | 'ios' | 'android'

// Capture/pick a photo as a File, mirroring the <input type=file> the web scan flow uses.
export async function capturePhotoFile({ source = 'prompt' } = {}) {
  if (!isNative) return null; // web keeps using the existing file input
  const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
  const src = source === 'camera' ? CameraSource.Camera
    : source === 'photos' ? CameraSource.Photos : CameraSource.Prompt;
  const photo = await Camera.getPhoto({
    quality: 90, resultType: CameraResultType.Uri, source: src, correctOrientation: true,
  });
  const resp = await fetch(photo.webPath);
  const blob = await resp.blob();
  return new File([blob], `scan_${Date.now()}.${photo.format || 'jpg'}`, { type: blob.type || 'image/jpeg' });
}

// Secure token storage (Keychain / Android Keystore) when native; no-op on web.
export async function secureSet(key, value) {
  if (!isNative) return;
  const { Preferences } = await import('@capacitor/preferences');
  await Preferences.set({ key, value });
}
export async function secureGet(key) {
  if (!isNative) return null;
  const { Preferences } = await import('@capacitor/preferences');
  return (await Preferences.get({ key })).value;
}
